<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex xl4 lg6 md7 sm10 xs12>
        <h2 class="pt-5 pb-5">{{ $t('e-billing_subscription') }}</h2>
        <v-form @submit.prevent="submitForm($event)" class="text-center">
          <v-text-field prepend-icon="fa-user-circle fa-lg" clearable autofocus :disabled="!!hasName" v-model="data.name" :label="$t('full_name')" name="full_name" :rules="[required]" required type="text"></v-text-field>
          <v-layout class="align-center justify-space-between" v-if="!$vuetify.breakpoint.xsOnly">
            <v-text-field prepend-icon="fa-envelope fa-lg" :error-messages="errors.collect('email_address')" :data-vv-as="$t('email_address')" v-model="data.recipient" :label="$t('email_address')" name="email_address" required type="text" v-validate="rules.email_address" :disabled="!!hasName || verify.result"></v-text-field>
            <v-btn color="primary" rounded outlined :disabled="currentTime > 0 || !validateEmail(data.recipient) || data.name.length === 0" @click="sendVerification" v-if="!verify.result && !hasSession">
              {{ sent ? $t(`resend_verification`, { channel: $t('email_address') }) : $t('send_verification', { channel: $t('email_address') }) }} <span v-if="currentTime > 0">({{ currentTime }} s)</span>
            </v-btn>
          </v-layout>
          <v-text-field v-if="$vuetify.breakpoint.xsOnly" prepend-icon="fa-envelope fa-lg" :error-messages="errors.collect('email_address')" :data-vv-as="$t('email_address')" :v-model="data.recipient" :label="$t('email_address')" name="email_address" required type="text" v-validate="rules.email_address" :disabled="!!hasName || verify.result"></v-text-field>
          <v-btn color="primary" rounded outlined :disabled="currentTime > 0 || !validateEmail(data.recipient) || data.name.length === 0" @click="sendVerification" v-if="!verify.result && $vuetify.breakpoint.xsOnly && !hasSession">
            {{ sent ? $t(`resend_verification`, { channel: $t('email_address') }) : $t('send_verification', { channel: $t('email_address') }) }} <span v-if="currentTime > 0">({{ currentTime }} s)</span>
          </v-btn>
          <v-layout justify-space-between class="align-center" v-if="sent">
            <v-text-field prepend-icon="fa-lock fa-lg" validate-on-blur :rules="[() => !!verify.input || 'This field is required']" v-model="verify.input" :label="$t('code')" name="code" required type="text" :disabled="verify.result"></v-text-field>
            <v-btn color="primary" rounded outlined :disabled="verify.input.length === 0 || verify.result" @click="verifyCode">
              {{ $t("verify") }}
            </v-btn>
          </v-layout>
          <br />
          <v-row justify="center" align="center">
            <v-col cols="12" xl="3" lg="3" md="3" sm="12" xs="12">
              <v-select v-model="account.type" :items="items" :label="$t('type')"></v-select>
            </v-col>
            <v-col cols="12" xl="7" lg="7" md="7" sm="12" xs="12">
              <v-text-field hint="please make sure the assessment account number is valid" :label="$t('assessment_no')" v-model="account.id" name="assessment_account_id" type="text" @keyup.enter="addAccount"></v-text-field>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="12" xs="12">
              <v-btn icon color="primary" :disabled="account.id && account.id.length < 0" @click="addAccount">
                <v-icon>fa-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <v-data-table
            :headers="headers"
            :items="data.accounts"
            :footer-props="{
              'items-per-page-options': [5, 10]
            }"
          >
            <template v-slot:item.type="{ item }">
              {{ $t(item.type) }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn color="error" icon @click="removeAccount(index)">
                <v-icon>fa-trash</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | date }}
            </template>
          </v-data-table>
          <!-- <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    {{ $t('type') }}
                  </th>
                  <th class="text-left">
                    {{ $t('account_no') }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data.accounts.length === 0">
                  <td colspan="3">
                    {{ $t("no_account") }}
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in data.accounts"
                  :key="item.id"
                  class="text-left"
                >
                  <td>{{ $t(item.type) }}</td>
                  <td>{{ item.id }}</td>
                  <td>
                    <v-btn color="error" icon @click="removeAccount(index)">
                      <v-icon>fa-trash</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table> -->
          <br />
          <v-layout class="row justify-space-around" pt-2>
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="red lighten-1" class="white--text" large rounded @click="$router.push('/')">{{ $t('cancel') }}</v-btn>
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" large rounded type="submit" :disabled="!verify.result || data.name === 0 || data.accounts.length === 0">{{ $t('subscribe') }}</v-btn>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { throttle } from 'lodash'

export default {
  data: () => ({
    currentTime: 0,
    account: { id: '', type: 'assessment', created_at: new Date().toISOString() },
    data: {
      accounts: [],
      name: '',
      recipient: '',
      subscriptions: ['e-billing'],
      type: 'email'
    },
    verify: {
      code: null,
      input: '',
      result: false
    },
    sent: false
  }),
  computed: {
    ...mapGetters({
      hasName: 'auth/hasName',
      hasSession: 'auth/hasSession'
    }),
    ...mapState({
      user: state => state.form.data,
      rules: (state) => state.form.rules
    }),
    headers () {
      return [
        {
          text: this.$t('type'),
          align: 'start',
          sortable: false,
          value: 'type'
        },
        {
          text: this.$t('account'),
          align: 'start',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('date'),
          align: 'start',
          sortable: true,
          value: 'created_at'
        },
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'action'
        }
      ]
    },
    isValid: function () {
      return Object.keys(this.fields).every((key) => this.fields[key].valid)
    },
    items () {
      return [
        { text: this.$t('assessment'), value: 'assessment' }
        // { text: this.$t('license'), value: 'license' }
      ]
    }
  },
  async created () {
    if (this.$store.getters['auth/hasName']) {
      this.$store.commit('form/setId', { id: this.$store.getters['auth/hasName'] })
      await this.$store.dispatch('form/fetchData')
    }
    if (this.user.name) {
      this.data.recipient = this.user.name.replace(/\s/g, '').toLowerCase()
      this.data.name = this.user.full_name.trim().toUpperCase()
      this.verify.result = true
    }
  },
  methods: {
    ...mapActions({
      sendEmail: 'form/sendEmail',
      submitData: 'form/submitData'
    }),
    countdown () {
      if (this.currentTime > 0) {
        this.currentTime -= 1
        setTimeout(this.countdown, 1000)
      } else {
        this.currentTime = 0
        this.verify.code = Math.floor(100000 + Math.random() * 900000).toString()
      }
    },
    required (value) {
      return !!value || this.$t('requiredField')
    },
    validateEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    addAccount () {
      const id = this.account.id.trim().toUpperCase()
      const index = this.data.accounts.findIndex(acc => acc.id === id)
      if (index < 0) {
        this.data.accounts.unshift({ type: this.account.type, id, created_at: new Date().toISOString() })
      }
      this.account.id = ''
    },
    removeAccount (index) {
      if (!index || index < 0) return
      this.data.accounts.splice(index, 1)
    },
    sendVerification: throttle(async function () {
      this.currentTime = 180
      this.verify.code = Math.floor(100000 + Math.random() * 900000).toString()
      setTimeout(this.countdown, 1)
      this.sent = true
      await this.sendEmail({
        contact: this.data.recipient.replace(/\s/g, '').toLowerCase(),
        message: `Hi ${this.data.name.trim().toUpperCase()},<br/><br/>Your MPT e-Services Email Verification Code is<br/><br/><strong>${this.verify.code}</strong><br/><br/>for e-Billing subscription MPT e-Services account. The code will expires in 3 mins.<br/><br/>*Note: If you didn't request any email verification code, please ignore this message.`
      })
    }, 1000),
    verifyCode () {
      if (this.verify.code === this.verify.input) {
        this.verify.result = true
        this.$store.dispatch('snackbar/setSnackBar', {color: 'success', message: this.$t('verify_successful'), visible: true})
        return
      }
      this.verify.result = false
      this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: this.$t('invalid_code'), visible: true})
    },
    submitForm: async function ($event) {
      if (!(await this.$validator.validateAll())) return

      this.$store.commit('form/setId', { id: this.data.recipient })
      await this.$store.dispatch('form/updateCommunication', { name: this.data.name, subscriptions: this.data.subscriptions })
    }
  }
}
</script>
